import { Scale } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { ASSO } from "@/constants";

export default function LegalNotice() {
  return (
    <div className="py-12 sm:py-16 lg:py-20" data-testid="legal-notice-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-emerald-600 mb-2">Informations légales</p>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900" data-testid="legal-notice-title">Mentions légales</h1>
        </div>

        <Card className="border-slate-200">
          <CardContent className="p-6 sm:p-8 space-y-6 text-sm leading-relaxed text-slate-600">
            <section className="space-y-2">
              <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2"><Scale className="h-5 w-5 text-emerald-600" />Éditeur du site</h2>
              <p>
                <strong>{ASSO.name}</strong> — association loi 1901 déclarée, domiciliée à Toury (28310), Eure-et-Loir, France.
              </p>
              <p>Président de l'association : {ASSO.president}.</p>
              <p>Contact : <a href={`mailto:${ASSO.email}`} className="text-sky-700 hover:underline">{ASSO.email}</a></p>
            </section>

            <section className="space-y-2">
              <h2 className="text-lg font-bold text-slate-900">Objet du site</h2>
              <p>
                Site d'information des familles de Toury : activités socio-éducatives et socio-culturelles, événements,
                actualités, calendrier scolaire (Zone B), adhésion à l'association et espaces réservés aux adhérents
                et aux candidats de la Liste CET (élections de parents d'élèves).
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-lg font-bold text-slate-900">Hébergement</h2>
              <p>
                Le site est hébergé sur une infrastructure cloud sécurisée (HTTPS/TLS). Les accès aux espaces
                personnels sont protégés par authentification chiffrée.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-lg font-bold text-slate-900">Propriété intellectuelle</h2>
              <p>
                L'ensemble des contenus du site (textes, visuels, logo de l'arbre CETF) est la propriété de
                l'association, sauf mention contraire. Toute reproduction sans autorisation écrite est interdite.
              </p>
            </section>

            <section className="space-y-2">
              <h2 className="text-lg font-bold text-slate-900">Liens externes</h2>
              <p>
                Le site contient des liens vers des sites tiers (HelloAsso pour l'adhésion et la billetterie,
                réseaux sociaux de l'association, sites institutionnels). L'association n'est pas responsable de
                leurs contenus.
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
